import moment from "moment-timezone";

export const maskNumber = (num: string): string => {
  if (!num || num.length <= 5) return num;
  return num.slice(0, 2) + "X".repeat(num.length - 5) + num.slice(-3);
};

export const navigationData = [
  {
    label: "Tickets",
    path: "/",
    src: "/images/ticket.png",
  },
  {
    label: "Ambulance",
    path: "/ambulance-trips",
    src: "/images/ticket.png",
  },
  // {
  //   label: "Outbound Calls",
  //   path: "/outboundCall",
  //   src: "/images/call.png",
  // },
  // {
  //   label: "Reset Password",
  //   path: "/resetPswd",
  //   src: "/images/lock-reset.png",
  // },
  {
    label: "Logout",
    path: "logout",
    src: "/images/logout.png",
  },
];

export const TicketStatus = [
  {
    label: "New",
    value: "New",
  },
  {
    label: "Work In Progress",
    value: "Work in progress",
  },
  {
    label: "Cancelled",
    value: "Cancelled",
  },
  {
    label: "Completed",
    value: "Completed",
  },
  // {
  //   label: "TestDemo",
  //   value: "TestDemo",
  // },
  // {
  //   label: "Customer Test",
  //   value: "Customer Test",
  // },
  // {
  //   label: "Internal Test",
  //   value: "Internal Test",
  // },
  // {
  //   label: "GeneralEnquiry",
  //   value: "GeneralEnquiry",
  // },

];

export const CompanyList = [
  {
    label: "Pococare",
    value: "Pococare",
  },
  {
    label: "Persistance",
    value: "Persistance",
  },
  {
    label: "Bioseed",
    value: "Bioseed",
  },
];
export const options = [
  {
    value: "Yes",
    label: "Yes",
  },
  {
    value: "No",
    label: "No",
  },
];

export const typesOfAssistanceReq = [
  {
    value: "wheelChair",
    label: "Wheelchair",
    icon: "/images/wheelchair.png",
  },
  {
    value: "stretcher",
    label: "Stretcher",
    icon: "/images/stretcher.png",
  },
  {
    value: "paramedic",
    label: "Paramedic",
    icon: "/images/paramedic.png",
  },
  {
    value: "additionalHelp",
    label: "Help",
    icon: "/images/additionalHelp.png",
  },
  {
    value: "DoctorOnBoard",
    label: "Doctor On Board",
    icon: "/images/doctorPic.png",
  },
];

export const transFormAssistanceValue: any = {
  wheelChair: "wheelchair",
  stretcher: "stretcher",
  paramedic: "paramedic",
  additionalHelp: "additionalHelp",
  DoctorOnBoard: "DoctorOnBoard"
}

export const questions: any = [
  { text: "Do you need Ambulance?", name: "isAmbulanceRequired" },
  {
    text: "Do you need doctor consultation?",
    name: "isDoctorConsultationRequired",
  },
];

export const AgentData = [
  {
    label: "agent1",
    value: "agent1",
  },
  {
    label: "agent2",
    value: "agent2",
  },
];
export const patientConditions: { label: string; value: string }[] = [
  {
    label: "Accident",
    value: "Accident",
  },
  {
    label: "Bleeding",
    value: "Bleeding",
  },
  {
    label: "Breathing Difficulty",
    value: "Breathing Difficulty",
  },
  {
    label: "Burn",
    value: "Burn",
  },
  {
    label: "Severe Pain",
    value: "Severe Pain",
  },
  {
    label: "Other",
    value: "Other",
  },
];



export const columns = [
  { title: "TICKET ID", dataIndex: "_id", key: "_id" },
  {
    title: "AGENT ID",
    key: "agent.fullName",
    render: (text: any, record: any) => record?.agent?.fullName,
  },
  {
    title: "BENEFICIARY",
    key: "ticketRaisedBy.fullName",
    render: (text: any, record: any) =>
      record?.patient?.fullName ||
      record?.ticketRaisedBy?.fullName ||
      "Unknown Beneficiary",
  },
  {
    title: "COMPANY",
    key: "companyName",
    render: (text: any, record: any) => record?.companyName,
  },
  {
    title: "DATE",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (text: any) => new Date(text).toLocaleString(),
  },
  { title: "STATUS", dataIndex: "ticketStatus", key: "ticketStatus" },
];
export const ticketDataTransform: any = {
  callerID: "Call from Phone",
  callerType: "Caller Type",
  sourceOfTicket: "Source of Call",
  companyName: "Client Of",
  campusId: "CampusId",
  poc: "POC",
  detectedLocation: "Address",
  subscriber: "Subscriber",
  doctorCount: "Doctor Consultation Count",
  ambulanceCount: "Subscriber Ambulance Count",
  beneficiaryAmbulanceCount: "Beneficiary Ambulance Count",
};
export const errorFormate = ({ e, service }: any) => {
  return e?.response?.data?.message || `Some Technical Issue in ${service}`;
};

export const payloadBuilderForObject = ({ fields, obj }: any) => {
  return fields.reduce((tempObj: any, key: any) => {
    if (key in obj) {
      tempObj[key] = obj[key];
    }
    return tempObj;
  }, {});
};

export const objectToArray = ({ fields, obj }: any) => {

  return fields.reduce((temArr: any, key: any) => {

    if (obj[key] !== undefined) {
      // Ensure the field exists in the object
      if (key === "detectedLocation") {
        let nestedField: any = obj["detectedLocation"];
        let label = ticketDataTransform[key];
        let addressLine = `${nestedField["address"] || ""},${nestedField["city"] || ""
          },${nestedField["state"] || ""},${nestedField["pinCode"] || ""},${nestedField["country"] || ""
          }`;
        temArr.push({ label, value: addressLine });
      } else if (key === "poc") {
        let label = ticketDataTransform[key];
        let nestedField = obj["poc"];
        temArr.push({
          label,
          value: nestedField["mobile"],
          name: nestedField["fullName"],
        });
      } else if (key === "subscriber") {
        // let label = ticketDataTransform[key];
        let key1 = "SubscriberName";
        let key2 = "SubscriberMobile";
        let nestedField = obj["subscriber"];
        temArr.push({
          label: key2,
          value: nestedField["mobile"],

        });
        temArr.push({
          label: key1,
          value: nestedField["fullName"],
        });
      } else if (key === "doctorDetails") {
        const doctor = obj?.doctorDetails;
        temArr.push({
          label: "isDoctorAvailable",
          value: doctor?.isAvailable ?? "N/A"
        });
        if (doctor?.isAvailable) {
          temArr.push({
            label: "doctorName",
            value: doctor?.doctorName ?? "N/A"
          });
          temArr.push({
            label: "doctorNumber",
            value: doctor?.doctorNumber?.number ?? "N/A"
          });

        }


      } else if (key === "nurseDetails") {
        const nurse = obj?.nurseDetails;
        temArr.push({
          label: "isNurseAvailable",
          value: nurse?.isAvailable ?? "N/A"
        });
        if (nurse?.isAvailable) {
          temArr.push({
            label: "nurseName",
            value: nurse?.nurseName ?? "N/A"
          });
          temArr.push({
            label: "nurseNumber",
            value: nurse?.nurseNumber?.number ?? "N/A"
          });

        }


      }
      else if (key === "ambulanceAvailability") {
        const ambulance = obj?.ambulanceAvailability;
        temArr.push({
          label: "isAmbulanceAvailable",
          value: ambulance?.isAvailable ?? "N/A"
        });
        if (ambulance?.isAvailable) {
          temArr.push({
            label: "ambulanceProviderName",
            value: ambulance?.ambulanceProviderName ?? "N/A"
          });
          temArr.push({
            label: "ambulanceNumber",
            value: ambulance?.ambulanceProviderNumber?.number ?? "N/A"
          });

        }
      }
      else {
        let label = ticketDataTransform[key];
        temArr.push({ label, value: obj[key] });
      }
    }


    else {
      if (key === "poc") {
        let label = ticketDataTransform[key];
        temArr.push({ label, value: obj[key] || "Poc N/A", name: "Poc N/A" });
      } else if (key === "subscriber") {
        let label = ticketDataTransform[key];
        temArr.push({ label, value: obj[key] || "N/A", name: "N/A" });
      }
      else {
        const label = ticketDataTransform?.[key] ?? key;
        const value = obj?.[key] ?? "N/A";
        temArr.push({ label, value });
      }
    }
    return temArr; // Return the accumulator
  }, []);
};
///emergencyCheck///
export const EmCheckOptions = [
  { value: "yes", label: "Yes" },
  { value: "maybe", label: "Maybe" },
  { value: "no", label: "No" },
];
export const EmMessages: any = {
  yes: "Please do not panic, we are here to help you. We will support you with a doctor consultation and ambulance if required. I will quickly take a few details so that we can start helping you immediately. Is that okay?",
  no: "Understood. I will still assist you. Please let me know how we can help you today.",
  maybe:
    "No problem, we will treat this as a medical emergency for now and get a doctor connected. Based on that, you can decide if further support like an ambulance is needed. Let me quickly take a few details. Is that okay?",
};
export function createWhatsappMessagePayload({
  templateName,
  data,
}: {
  templateName: string;
  data: any;
}) {
  return {
    template: templateName,
    data: {
      ...data,
    },
  };
}
export const insuranceFieldTransformer: any = {
  policyId: "Policyid",
  docUrl: "Document",
  nameOfInsurer: "Nameofinsurer",
  expiry: "Expiry",
  tpaName: "TPA Name",
  typeOfPolicy: "Type of Policy",
  callerId: "Callerid",
  duration: "Duration",
  startTime: "StartTime",
  endTime: "EndTime",
  timeToAnswer: "TimeToAnswer",
  status: "Status",
  hangupBy: "HangupBy",
  agentId: "Agentid",
  dialStatus: "DialStatus",
  callType: "CallType"
}
export const benDataTransformer = (benData: any) => {
  return benData
    .map((ben: any) => ({
      value: ben.subscriberId + "," + ben._id,
      label: ben?.personalInfo?.fullName,
    }))
    .filter((el: any) => el.value !== undefined || el.label !== undefined);
};
export function generateUniqueID() {
  const timestamp = ((new Date().getTime() / 1000) | 0).toString(16);
  const randomChars = Math.random().toString(16).substring(2, 8);
  const uniqueID = timestamp + randomChars;
  return uniqueID;
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}


export function transformLowerCase(string: string) {
  // eslint-disable-next-line
  return string?.replace(/\p{Z}/gu, "")
    .toLowerCase();

};

export const removeFieldFn = (
  data: any,
  // generateSaSToken: any, 
  excludedField: any) => {

  const filteredData: any = data.map((benData: any) => {
    // generateSaSToken()
    return Object.fromEntries(
      Object.entries(benData).filter(
        ([key, value]) => !excludedField.includes(key)
      )
    );
  })
  return filteredData
}
export const currentDateTime = () => {
  return moment().tz("Asia/Kolkata").format("YYYY-MM-DD HH:mm:ss");
};


export const agentNotesUpdateFun = (isTicketDataPresent: any, message: any) => {
  let messageArr = []
  for (let i = 0; i < message.length; i++) {
    messageArr.push({ date: currentDateTime(), message: message[i] })
  }
  const TicketUpdateTracking = {
    notes: [...isTicketDataPresent?.notes, ...messageArr]
  };
  return TicketUpdateTracking;
}

export const DoctorConsultDeniedScript =
  '"I would still suggest that you speak to the doctor while we arrange the ambulance. In many cases, an early doctor consultation helps manage the emergency better before the ambulance arrives."';

export const EmStartNotification =
  "We will immediately dispatch an ambulance and set up a doctor’s consultation. Please stay available on Whatsapp for an online video consultation with the doctor. Thank you for reaching out to the Pococare Heartbeat team.";

export const cancelledTicketText =
  "I am sorry, but Pococare services are for medical emergencies only. We provide ambulance and virtual doctor consultation for such cases. If you do not require any of the above service I will close this ticket";


export const storeDataInSessionStorage = (key: string, value: any) => {
  sessionStorage.setItem(key, JSON.stringify(value));
}
export const getSessionStorage = (key: string) => {
  return JSON.parse(sessionStorage.getItem(key) || "{}");
}

export const removeSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
}

export const clearSessionStorage = () => {
  sessionStorage.clear();
}


export const backgroundTask = (task: any, delay: number) => {
  return setTimeout(task, delay);
}


export const debounce = (func: any, delay: number) => {
  let timeoutId: any;
  return (...args: any) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}